import { createSelector } from 'reselect';
import { activeSelector } from 'selectors/testTarget/offers/highlightValueOnValueSetsHP/active/activeSelector';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';

const activeHighlightValueOnValueSetsHPSelector = createSelector(
    isTestTargetReadySelector,
    activeSelector,
    (testReady, active) => testReady && active
);

export { activeHighlightValueOnValueSetsHPSelector };
